import { render, staticRenderFns } from "./NodalPCQuickLook.vue?vue&type=template&id=041ef6fb&"
import script from "./NodalPCQuickLook.vue?vue&type=script&lang=js&"
export * from "./NodalPCQuickLook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol,VContainer,VRow,VSelect,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('041ef6fb')) {
      api.createRecord('041ef6fb', component.options)
    } else {
      api.reload('041ef6fb', component.options)
    }
    module.hot.accept("./NodalPCQuickLook.vue?vue&type=template&id=041ef6fb&", function () {
      api.rerender('041ef6fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/NodalPCQuickLook.vue"
export default component.exports